import { setActivePaginationPage } from "@global-state/pages/admin/costs/slice";
import { useGetAllCostsQuery } from "@RTKQuery/admin/cost/cost";
import { Pagination } from "@ui";
import { useAppSelector, useAppDispatch } from "store/hooks";

export function PaginationContainer() {
    const { activeEndDate, activeStartDate, activePaginationPage, activeTagFilter } = useAppSelector(state => state.costsAdminPage);

    const { data } = useGetAllCostsQuery({
        page: activePaginationPage,
        end_date: activeEndDate,
        start_date: activeStartDate,
        tag_id: activeTagFilter
    });

    const dispatch = useAppDispatch();

    if (data?.count_items) {
        return (
            <div className="w-fit mx-auto mb-[20px]">
                <Pagination
                    activePage={activePaginationPage - 1}
                    count={Math.ceil((data?.count_items || 0) / 50)}
                    onClickPage={(page) => {
                        dispatch(setActivePaginationPage(page + 1))
                    }}
                />
            </div>
        )
    } else {
        return null;
    }
}